import React, { useEffect, useState } from "react";
import socket from "./socket";
import GameBoard from "./GameBoard";

function SepticaContainer() {
  const [roomId, setRoomId] = useState("abc");
  const [inGame, setInGame] = useState(true);
  const [maxPlayers, setMaxPlayers] = useState(2);

  useEffect(() => { socket.emit("joinGame", { roomId });},[])

  const createGame = () => {
    socket.emit("createGame", { roomId, maxPlayers });
    setInGame(true);
  };

  const joinGame = () => {
    socket.emit("joinGame", { roomId });
    setInGame(true);
  };

  return         <GameBoard roomId={roomId} />

  return (
    <div style={{ textAlign: "center", padding: 20 }}>
      {!inGame ? (
        <div>
          <h1>🃏 Septica Online</h1>
          <input
            type="text"
            placeholder="Room ID"
            value={roomId}
            onChange={(e) => setRoomId(e.target.value)}
          />
          <br /><br />
          <select value={maxPlayers} onChange={(e) => setMaxPlayers(+e.target.value)}>
            <option value={2}>2 jucători</option>
            <option value={3}>3 jucători</option>
            <option value={4}>4 jucători</option>
          </select>
          <br /><br />
          <button onClick={createGame}>Creează Cameră</button>
          <button onClick={joinGame} style={{ marginLeft: 10 }}>Alătură-te</button>
        </div>
      ) : (
        <GameBoard roomId={roomId} />
      )}
    </div>
  );
}

export default SepticaContainer;
